import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import CostCenterDataService from "../../services/costCenter.service";

// FORM VALIDATION
import { useFormik } from "formik";
import * as Yup from "yup";

import BackButton from "../BackButton";

const CostCenter = (props) => {
    const initialCostCenterState = {
        id: null,
        name: "",
    };
    const [currentCostCenter, setCurrentCostCenter] = useState(
        initialCostCenterState
    );
    const [message, setMessage] = useState("");

    const { id } = useParams();
    let navigate = useNavigate();

    const getCostCenter = (id) => {
        CostCenterDataService.get(id)
            .then((response) => {
                setCurrentCostCenter(response.data);
                formik.values = {
                    name: response.data.name,
                };
            })
            .catch((e) => {
                console.log(e);
            });
    };

    useEffect(() => {
        if (id) getCostCenter(id);
    }, [id]);

    // FORM VALIDATION
    const form = useRef();
    const checkBtn = useRef();

    const [successful, setSuccessful] = useState(false);

    const validationSchema = Yup.object().shape({
        name: Yup.string()
            .required("Name is required")
            .min(6, "Name must be at least 6 characters")
            .max(20, "Name must not exceed 20 characters"),
    });

    const formik = useFormik({
        initialValues: {
            name: currentCostCenter.name,
        },
        enableReinitialize: true,
        validationSchema,
        // validateOnChange: false,
        // validateOnBlur: false,
        onSubmit: () => {
            CostCenterDataService.update(currentCostCenter.id, formik.values)
                .then((response) => {
                    setSuccessful(true);
                    console.log(response.data);
                    setMessage("The cost center was updated successfully!");
                    navigate("/costCenters");
                })
                .catch((e) => {
                    setSuccessful(false);
                    console.log(e);
                });
        },
    });

    const deleteCostCenter = () => {
        CostCenterDataService.remove(currentCostCenter.id)
            .then((response) => {
                console.log(response.data);
                navigate("/costCenters");
            })
            .catch((e) => {
                // console.log(e);
                window.alert(e.response.data.message);
            });
    };

    return (
        <div>
            {currentCostCenter ? (
                <div className="col-md-12 module-form">
                    <BackButton returnPath="/costCenters"></BackButton>

                    <h4 className="page-title">Update cost center</h4>

                    <form onSubmit={formik.handleSubmit} ref={form}>
                        {!successful && (
                            <div>
                                <div className="form-group">
                                    <label htmlFor="name"> Name </label>
                                    <input
                                        name="name"
                                        type="text"
                                        className={
                                            "form-control" +
                                            (formik.errors.name &&
                                            formik.touched.name
                                                ? " is-invalid"
                                                : "")
                                        }
                                        onChange={formik.handleChange}
                                        value={formik.values.name}
                                    />
                                    <div className="invalid-feedback">
                                        {formik.errors.name &&
                                        formik.touched.name
                                            ? formik.errors.name
                                            : null}
                                    </div>
                                </div>

                                <hr></hr>

                                <div className="form-group">
                                    <button
                                        type="submit"
                                        className="btn btn-primary"
                                    >
                                        Update
                                    </button>{" "}
                                    <button
                                        type="button"
                                        className="btn btn-danger float-right"
                                        onClick={deleteCostCenter}
                                    >
                                        Delete
                                    </button>
                                </div>
                            </div>
                        )}

                        {/* {message && (
                            <div className="form-group">
                                <div
                                    className={
                                        successful
                                            ? "alert alert-success"
                                            : "alert alert-danger"
                                    }
                                    role="alert"
                                >
                                    {message}
                                </div>
                            </div>
                        )}
                        <button
                            style={{ display: "none" }}
                            ref={checkBtn}
                        ></button> */}
                    </form>
                </div>
            ) : (
                <div>
                    <br />
                    <p>Please click on a Cost Center...</p>
                </div>
            )}
        </div>
    );
};

export default CostCenter;
